class CartCheckboxUpsell {
  constructor() {
    this.busy = false;
    document.body.addEventListener("change", (e) => {
      if (e.target.id !== "cart-upsell-checkbox" || this.busy) return;
      if (e.target.checked) {
        sessionStorage.removeItem("upsellOptedOut");
        this.add();
      } else {
        sessionStorage.setItem("upsellOptedOut", "1");
        this.remove();
      }
    });
  }

  vid() {
    var cb = document.querySelector("#cart-upsell-checkbox");
    return cb ? cb.getAttribute("data-variant-id") : null;
  }

  add() {
    if (this.busy) return;
    this.busy = true;
    var variantId = this.vid();
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties: { _source: 'cart-upsell-guarantee' } }] })
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-checkbox-upsell', productVariantId: variantId, cartData: response });
      }
      fetch('https://data.bellom.co/api/track',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({type:'atc_source',source:'cart-upsell-guarantee',product:'Garantie Sérénité'})}).catch(function(){});
    })
    .then(() => this.refreshDrawer())
    .catch(() => { this.busy = false; });
  }

  remove() {
    if (this.busy) return;
    this.busy = true;
    var vid = this.vid();
    fetch("/cart.js").then(r => r.json()).then((cart) => {
      var idx = -1;
      cart.items.forEach((item, i) => { if (item.variant_id.toString() === vid) idx = i; });
      if (idx === -1) { this.busy = false; return; }
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: idx + 1, quantity: 0 })
      });
    })
    .then(function() {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-checkbox-upsell-remove', productVariantId: vid });
      }
    })
    .then(() => this.refreshDrawer())
    .catch(() => { this.busy = false; });
  }

  refreshDrawer() {
    var url = (typeof routes !== "undefined" && routes.cart_url ? routes.cart_url : "/cart") + "?section_id=cart-drawer";
    Promise.all([
      fetch(url).then(r => r.text()),
      fetch("/cart.js").then(r => r.json())
    ]).then(([html, cart]) => {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var n, o;
      if ((n = doc.querySelector("cart-drawer-items")) && (o = document.querySelector("cart-drawer-items"))) o.innerHTML = n.innerHTML;
      if ((n = doc.querySelector(".drawer__footer")) && (o = document.querySelector(".drawer__footer"))) o.innerHTML = n.innerHTML;
      // Sync checkbox
      var cb = document.querySelector("#cart-upsell-checkbox");
      var opted = sessionStorage.getItem("upsellOptedOut") === "1";
      if (cb) cb.checked = !opted;
      // Update button
      var btn = document.getElementById("CartDrawer-Checkout");
      if (btn) btn.textContent = "Procéder au paiement - " + (cart.total_price / 100).toFixed(2).replace(".", ",") + " EUR";
      this.busy = false;
    }).catch(() => { this.busy = false; });
  }
}

document.addEventListener("DOMContentLoaded", () => new CartCheckboxUpsell());
